var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "screen"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.6875 1.5H14.3125C15.2238 1.50107 16.0976 1.85491 16.742 2.48391C17.3864 3.11291 17.7489 3.96572 17.75 4.85526V11.1316C17.7489 12.0211 17.3864 12.8739 16.742 13.5029C16.0976 14.1319 15.2238 14.4858 14.3125 14.4868H4.6875C3.77615 14.4858 2.90245 14.1319 2.25803 13.5029C1.61361 12.8739 1.25109 12.0211 1.25 11.1316V4.85526C1.25109 3.96572 1.61361 3.11291 2.25803 2.48391C2.90245 1.85491 3.77615 1.50107 4.6875 1.5ZM15.7709 12.5551C16.1577 12.1776 16.375 11.6655 16.375 11.1316V4.85526C16.375 4.32134 16.1577 3.80929 15.7709 3.43175C15.3841 3.05421 14.8595 2.84211 14.3125 2.84211H4.6875C4.14049 2.84211 3.61589 3.05421 3.22909 3.43175C2.8423 3.80929 2.625 4.32134 2.625 4.85526V11.1316C2.625 11.6655 2.8423 12.1776 3.22909 12.5551C3.61589 12.9326 4.14049 13.1447 4.6875 13.1447H14.3125C14.8595 13.1447 15.3841 12.9326 15.7709 12.5551Z",
    fill: "#1E1A21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8125 15.1553V15.1579H6C5.81766 15.1579 5.6428 15.2286 5.51386 15.3544C5.38493 15.4803 5.3125 15.651 5.3125 15.8289C5.3125 16.0069 5.38493 16.1776 5.51386 16.3035C5.6428 16.4293 5.81766 16.5 6 16.5H13C13.1823 16.5 13.3572 16.4293 13.4861 16.3035C13.6151 16.1776 13.6875 16.0069 13.6875 15.8289C13.6875 15.651 13.6151 15.4803 13.4861 15.3544C13.3572 15.2286 13.1823 15.1579 13 15.1579H10.1875V15.1553H8.8125Z",
    fill: "#1E1A21"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreen);
export default __webpack_public_path__ + "static/media/screen.b002311f7f2e2e0598b962d4c97c3a95.svg";
export { ForwardRef as ReactComponent };